export class InpageMenuHolderBlock {
    private window: any = window;
    private tabs: JQuery;
    private defaultMenuitems: JQuery;
    private readonly desktopBreakpoint = 992;

    constructor() {
        this.defaultMenuitems = $(".inpagemenu-links li a.selected");
        
        this.init();
        //get first tab as default
    }
    private init() {
        this.defaultMenuitems.each((i, e) => {
            var selectedMenuItem = $(e);
            $("#".concat(selectedMenuItem.data("target"))).load(selectedMenuItem.data("href").concat(" article"), () => {
                this.updateEqualHeights("#".concat(selectedMenuItem.data("target")));
            });
            
        });
    }

    private updateEqualHeights(wrapper: string) {
        const winWidth = $(this.window).width();

        $(wrapper + ' .equal-height').each((i, e) => {
            const el: any = $('.equalize', $(e));

            if (winWidth > this.desktopBreakpoint) {
                el.matchHeight(false);
            }
            else {
                el.matchHeight("remove");
            }
        });
    }

}

